import { QueryOperatorEntity } from '~/types/OpenSearch';

export const AND: QueryOperatorEntity = { type: 'operator', value: 'and' };
export const OR: QueryOperatorEntity = { type: 'operator', value: 'or' };
